<template>
  <div :class="$style.header">
    <img
      :class="$style.logo"
      src="@/images/Logotype.svg"
      alt="logo"
      @click="handleLogoClick"
    />
    <div :class="$style.logIn">
      <UiKitTypography :type="MAP.B04D" :class="$style.logInTitle"
        >Already have an account?</UiKitTypography
      >
      <UiKitButton
        :variant="'outlined'"
        :class="$style.logInButton"
        @click="$emit('log_in')"
        >Log in</UiKitButton
      >
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from "vue";
import { MAP } from "@/constants/typography";
import UiKitTypography from "@/ui-kit/Typography.vue";
import UiKitButton from "@/ui-kit/Button.vue";

defineEmits(["log_in"]);

const handleLogoClick = () => {
  window.location.href = "https://hackenproof.com";
};
</script>

<style module lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  width: 100%;
  .logIn {
    display: flex;
    align-items: center;
    gap: 16px;

    .logInTitle {
      @media screen and (max-width: 760px) {
        display: none;
      }
    }

    .logInButton {
      outline: 2px solid #050505 !important;
    }
  }

  .logo {
    cursor: pointer;

    @media screen and (max-width: 1439px) {
      height: 32px;
    }
  }
}
</style>
